import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="main">
      <div className="heroContainer">
        <header className="header">
          <h1>
            Book your next holiday <br /> destination with us!
          </h1>
        </header>
        <p className="text">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae hac
          urna, <br /> enim arcu luctus ipsum dolor sollicitudin pharetra.
          Semper imperdiet egestas.
        </p>
      </div>
    </div>
  );
};

export default Hero;
